export default __webpack_public_path__ + "static/media/Mulish-Light.c31acf42.ttf";